export default () => (window.innerWidth >= 500 ? 'desktop' : 'mobile');
